import api from './HttpService';
import { CLIENT } from '../configs/ApiActionUrl';

async function getAll(pageOption, sortData, keyword, departmentName) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (keyword) {
    query += `&search_key=${keyword}`;
  }

  if (departmentName) {
    query += `&department_name=${departmentName}`;
  }

  try {
    const res = await api.get(CLIENT.LIST + query);
    return res;
  } catch (error) {
    // Handle errors here
    return error; // Rethrow the error to propagate it further
  }
}

async function add(postData) {
  const res = await api.post(CLIENT.ADD, postData);
  return res;
}

async function getItem(code) {
  const res = await api.get(`${CLIENT.EDIT}/${code}`);
  return res;
}

async function update(code, postData) {
  const res = await api.patch(`${CLIENT.UPDATE}/${code}`, postData);
  return res;
}

async function deleteItem(code) {
  const res = await api.delete(`${CLIENT.DELETE}/${code}`);
  return res;
}

async function getCompanyClient(code) {
  const res = await api.get(`${CLIENT.BASED_ON_COMPANY}/${code}`);
  return res;
}

async function getActiveItem() {
  const res = await api.get(`${CLIENT.ACTIVE}`);
  return res;
}

async function importClients(formData) {
  const res = await api.post(CLIENT.IMPORT, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
}

async function downloadImportTemplate() {
  const res = await api.get(CLIENT.IMPORT_TEMPLATE, { responseType: 'blob' });
  return res;
}

const clientService = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getCompanyClient,
  getActiveItem,
  importClients,
  downloadImportTemplate
};

export default clientService;
